import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import styles from './infoList.module.css';
import size from 'lodash/size';

function InfoList({ IconElement, title, data = [], containerClassName = '' }) {
  return (
    <Box
      p={6}
      rounded="xl"
      className={`${styles.container} ${containerClassName}`}
    >
      <Flex direction={'row'} alignItems={'center'} gap={3} mb={'16px'}>
        <IconElement className={styles.icon} />
        <Box className={styles.title}>{title}</Box>
      </Flex>
      {size(data) > 0 && (
        <Flex direction={'column'} gap={3}>
          {data.map((item, index) => (
            <Flex key={item} className={styles.item} gap={3}>
              <Box className={styles.icon}>
                <Box className={styles.dot}>{index + 1}</Box>
              </Box>
              <Box className={styles.text}>{item}</Box>
            </Flex>
          ))}
        </Flex>
      )}
    </Box>
  );
}

export default InfoList;
